// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"243":"91e78fe3","354":"64c4e108","920":"a58a4dad"}[chunkId] + ".css";
};